module.exports = __webpack_public_path__ + "img/18_88.b237c7ad.png";